export enum ACTION_TYPE {
  SET_MODE = 'setmode',
  TOGGLE_FEATURE_FLAG = 'togglefeatureflag',
  CLEAR_FLAG_OVERRIDES = 'clearflagoverrides',
  SET_REDIRECT_TO_PRESETUP = 'setredirecttopresetup',
}

export const ACTION = {
  SET_MODE: () => `/?_index&action=${ACTION_TYPE.SET_MODE}`,
  TOGGLE_FEATURE_FLAG: (flag: { [x: string]: boolean }) => `/?_index&action=${ACTION_TYPE.TOGGLE_FEATURE_FLAG}&flag=${Object.keys(flag)[0]}&value=${Object.values(flag)[0]}`,
  CLEAR_FLAG_OVERRIDES: () => `/?_index&action=${ACTION_TYPE.CLEAR_FLAG_OVERRIDES}`,
  SET_REDIRECT_TO_PRESETUP: ({ redirect }: { redirect: boolean }) => `/sp-admin/presetup?action=${ACTION_TYPE.SET_REDIRECT_TO_PRESETUP}&redirect=${redirect}`,
}
